var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6468 12.22C14.6468 12.46 14.5935 12.7067 14.4802 12.9467C14.3668 13.1867 14.2202 13.4133 14.0268 13.6267C13.7002 13.9867 13.3402 14.2467 12.9335 14.4133C12.5335 14.58 12.1002 14.6667 11.6335 14.6667C10.9535 14.6667 10.2268 14.5067 9.46016 14.18C8.6935 13.8533 7.92683 13.4133 7.16683 12.86C6.40016 12.3 5.6735 11.68 4.98016 10.9933C4.2935 10.3 3.6735 9.57334 3.12016 8.81334C2.5735 8.05334 2.1335 7.29334 1.8135 6.54001C1.4935 5.78001 1.3335 5.05334 1.3335 4.36001C1.3335 3.90668 1.4135 3.47334 1.5735 3.07334C1.7335 2.66668 1.98683 2.29334 2.34016 1.96001C2.76683 1.54001 3.2335 1.33334 3.72683 1.33334C3.9135 1.33334 4.10016 1.37334 4.26683 1.45334C4.44016 1.53334 4.5935 1.65334 4.7135 1.82668L6.26016 4.00668C6.38016 4.17334 6.46683 4.32668 6.52683 4.47334C6.58683 4.61334 6.62016 4.75334 6.62016 4.88001C6.62016 5.04001 6.5735 5.20001 6.48016 5.35334C6.3935 5.50668 6.26683 5.66668 6.10683 5.82668L5.60016 6.35334C5.52683 6.42668 5.4935 6.51334 5.4935 6.62001C5.4935 6.67334 5.50016 6.72001 5.5135 6.77334C5.5335 6.82668 5.5535 6.86668 5.56683 6.90668C5.68683 7.12668 5.8935 7.41334 6.18683 7.76001C6.48683 8.10668 6.80683 8.46001 7.1535 8.81334C7.5135 9.16668 7.86016 9.49334 8.2135 9.79334C8.56016 10.0867 8.84683 10.2867 9.0735 10.4067C9.10683 10.42 9.14683 10.44 9.1935 10.46C9.24683 10.48 9.30016 10.4867 9.36016 10.4867C9.4735 10.4867 9.56016 10.4467 9.6335 10.3733L10.1402 9.87334C10.3068 9.70668 10.4668 9.58001 10.6202 9.50001C10.7735 9.40668 10.9268 9.36001 11.0935 9.36001C11.2202 9.36001 11.3535 9.38668 11.5002 9.44668C11.6468 9.50668 11.8002 9.59334 11.9668 9.70668L14.1735 11.2733C14.3468 11.3933 14.4668 11.5333 14.5402 11.7C14.6068 11.8667 14.6468 12.0333 14.6468 12.22Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6.00002C12.3333 5.60002 12.02 4.98669 11.5533 4.48669C11.1267 4.02669 10.56 3.66669 10 3.66669",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 6.00001C14.6667 3.42001 12.58 1.33334 10 1.33334",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e1c94d92a87662a008d8daca98a17951.svg";
export { ForwardRef as ReactComponent };